/**
 * Cams API
 * Cams
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ShareTypeResponse { 
    id?: number;
    name?: string | null;
    accountId?: number | null;
    accountCode?: string | null;
    accountNumber?: string | null;
    accountName?: string | null;
    perShareValue?: number | null;
    allowedAsGuarantor?: boolean;
    allowedAsCollateral?: boolean;
}

